
import styled from 'styled-components';

interface Props {
  heigth?:number
}

export const StalkFullContainer = styled.div<Props>`
display: flex;
/* border: 1px solid gray; */
flex-direction: column;
align-items: center;
/* background-color: yellow; */
height: 93%;
animation: scale-up-ver-bottom 3s;

.containerExtern {
  height: 427px;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
}

@keyframes scale-up-ver-bottom{0%{transform:scaleY(.4);transform-origin:0 100%}100%{transform:scaleY(1);transform-origin:0 100%}}
`